function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLeafBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 14.875 14.273438 C 17.335938 11.808594 17.929688 3.703125 17.929688 3.703125 C 16.554688 4.332031 15.078125 4.707031 13.570312 4.804688 C 11.050781 5.019531 8.714844 5.378906 7.332031 6.746094 C 5.234375 8.859375 4.707031 11.863281 5.910156 13.984375 C 7.230469 11.917969 12.671875 8.949219 12.671875 8.949219 C 8.765625 11.742188 4.277344 17.042969 4.097656 17.722656 C 3.917969 18.402344 5.210938 18.425781 5.410156 18.074219 C 5.613281 17.722656 6.390625 16.308594 7.246094 15.453125 C 9.375 16.96875 12.628906 16.519531 14.875 14.273438 Z M 14.875 14.273438 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLeafBlack);
export default __webpack_public_path__ + "static/media/icon_leaf_black.1842e9602e1eee330ec83e1627062e4c.svg";
export { ForwardRef as ReactComponent };